/**
 * CartProgressBar — fallback updater for cases where morph doesn't cover.
 * Primary update path is Section Rendering API + morphSection (server-rendered Liquid).
 * This JS only fires if the morph doesn't update data-current within 800ms of a cart:update.
 */
class CartProgressBar extends HTMLElement {
  static get observedAttributes() { return ['data-current']; }

  connectedCallback() {
    document.addEventListener('cart:update', this._onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this._onCartUpdate);
    clearTimeout(this._timer);
  }

  attributeChangedCallback() {
    clearTimeout(this._timer);
  }

  _onCartUpdate = () => {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => this._fetchAndUpdate(), 800);
  };

  _fetchAndUpdate() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const threshold = parseInt(this.dataset.threshold) || 7500;
        const current = cart.total_price;
        // FLOW = livraison offerte systematique (profil dedie) → barre toujours complete
        const flowFree = (cart.items || []).some(it => it.handle === 'flow-softlift-soutien-gorge-sans-armatures' || it.product_id === 16429508821337);
        const pct = flowFree ? 100 : Math.min(100, Math.round((current / threshold) * 100));
        const fill = this.querySelector('[data-fill]');
        const msg = this.querySelector('[data-message]');

        if (fill) fill.style.width = pct + '%';

        if (flowFree || current >= threshold) {
          this.classList.add('is-complete');
          if (msg) msg.textContent = this.dataset.successMsg || '🎉 Livraison offerte !';
        } else {
          this.classList.remove('is-complete');
          if (msg) {
            const remaining = ((threshold - current) / 100).toFixed(2).replace('.', ',');
            const template = this.dataset.msgTemplate || 'Plus que {amount} pour la livraison offerte';
            msg.innerHTML = template.replace('{amount}', '<strong>' + remaining + ' €</strong>');
          }
        }

        this.dataset.current = String(current);
      })
      .catch(() => {});
  }
}

if (!customElements.get('cart-progress-bar')) {
  customElements.define('cart-progress-bar', CartProgressBar);
}
